import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Tasks from "@/pages/Tasks";
import Vault from "@/pages/Vault"; // kept for backward-compat route (deprecated)
import Calendar from "@/pages/Calendar";
import Documents from "@/pages/Documents";
import Reports from "@/pages/Reports";
import AuditLog from "@/pages/AuditLog";
import Team from "@/pages/Team";
import Recurring from "@/pages/Recurring";
import Billing from "@/pages/Billing";
import Outstanding from "@/pages/Outstanding";
import PublicInvoice from "@/pages/PublicInvoice";
import FirmSettings from "@/pages/FirmSettings";
import { Toaster } from "@/components/ui/sonner";

export default function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/pay/:id" element={<PublicInvoice />} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/clients" element={<Clients />} />
              <Route path="/clients/:id" element={<ClientDetail />} />
              <Route path="/tasks" element={<Tasks />} />
              <Route path="/recurring" element={<Recurring />} />
              <Route path="/calendar" element={<Calendar />} />
              <Route path="/vault" element={<Vault />} />
              <Route path="/documents" element={<Documents />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/billing" element={<Billing />} />
              <Route path="/outstanding" element={<Outstanding />} />
              <Route path="/team" element={<Team />} />
              <Route path="/firm" element={<FirmSettings />} />
              <Route path="/audit" element={<AuditLog />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </ThemeProvider>
  );
}
